module.exports = __webpack_public_path__ + "hero-desktop.a412fe526a54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/marketing/home/hero-desktop.jpg
// module id = ./src/styles/marketing/home/hero-desktop.jpg
// module chunks = 21